import { CSS_RESET } from '../css-reset.js';
import * as index from './components/index.js';
import { red, yellow, green, blue, slate, grayscale, purple } from './tokens/colors.js';
import { combinedTokens } from './tokens/semanticTokens.js';
import { breakpoints } from './tokens/breakpoints.js';
import { space } from './tokens/space.js';
import { sizes } from './tokens/sizes.js';
import { radii } from './tokens/radii.js';
import { fontWeights, lineHeights, fontSizes, fonts } from './tokens/font.js';
import { shadows } from './tokens/shadows.js';

const theme = {
  semanticTokens: combinedTokens,
  colors: {
    red,
    yellow,
    green,
    blue,
    slate,
    grayscale,
    purple
  },
  styles: {
    global: {
      ...CSS_RESET,
      html: {
        lineHeight: 1.5,
        WebkitFontSmoothing: "antialiased",
        textRendering: "optimizeLegibility",
        MozOsxFontSmoothing: "grayscale",
        touchAction: "manipulation",
        WebkitTextSizeAdjust: "100%"
      },
      body: {
        fontFamily: "Arial, system-ui, sans-serif",
        fontFeatureSettings: '"kern"',
        bgColor: "background-body"
      }
    }
  },
  borders: {},
  breakpoints,
  direction: "ltr",
  space,
  sizes,
  radii,
  fontWeights,
  lineHeights,
  fontSizes,
  fonts,
  shadows,
  transition: {
    property: {},
    easing: {},
    duration: {}
  },
  zIndices: {
    // from chakra-ui
    hide: -1,
    auto: "auto",
    base: 0,
    docked: 10,
    dropdown: 1e3,
    sticky: 1100,
    banner: 1200,
    overlay: 1300,
    modal: 1400,
    popover: 1500,
    skipLink: 1600,
    toast: 1700,
    tooltip: 1800
  },
  letterSpacings: {},
  components: index,
  config: {
    useSystemColorMode: false,
    initialColorMode: "light",
    cssVarPrefix: "vimeo"
  }
};

export { theme };
